// Downloads each file of a manual shipment's labels or declarations as
// "<tracking>_<type>_<n>.<ext>". Used by the row menu and by the Label /
// Decl buttons in the Shipping column.
export const printMultipleFiles = async (data, shipment) => {
  try {
    data?.forEach(async (label, index) => {
      const response = await fetch(label.file, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));

      // Extract file extension from the URL
      const fileExtension = label.file.split(".").pop();

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${shipment}_${label.type}_${index + 1}.${fileExtension}`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  } catch (error) {
    console.error("Error downloading labels:", error);
    // Handle error here
  }
};
